<!-- <h4>You are being redirected to an external web site for payment processing.  Click OK to continue
</h4> -->
<form #formRef [action]="fisPayment?.fisGatewayPostUrl" method="POST">
  <input type="hidden" name="Xml" [value]="fisPayment?.fisGatewayXml" />
  <input type="hidden" name="MerchantCode" [value]="fisPayment?.fisGatewayMerchantCode" />
  <!-- <button class="favorite styled" type="button">Ok</button> -->
</form>

<div class="m-3">
    <h1> Workers' Compensation Exemption Registration</h1>
  </div>

<div style="margin-top: 20px;">
  <div >
    <div class="row ">
      <div class="col-6">
        <div class="row">
            <div class="col-5" >Registration Control #</div>
            <div class="col-7" style="font-weight: bold;">{{data?.registrationControlNumber}}</div>
          </div>
        <div class="row">
          <div class="col-5" >Registrant Name</div>
          <div class="col-7" style="font-weight: bold;">{{data?.firstName + ' ' + data?.lastName}}</div>
        </div>
        <div class="row">
            <div class="col-5" >Entity Business Name</div>
            <div class="col-7" style="font-weight: bold;">{{data?.filingEntityName}}</div>
          </div>
          <div class="row">
            <div class="col-5" >Address</div>
            <div class="col-7" style="font-weight: bold;">{{data?.mailingAddress?.address1}}</div>
          </div>
          <div class="row">
            <div class="col-5" >City</div>
            <div class="col-7" style="font-weight: bold;">{{data?.mailingAddress?.city}}</div>
          </div>
          <div class="row">
            <div class="col-5" >State</div>
            <div class="col-7" style="font-weight: bold;">{{data?.mailingAddress?.state?.abbrv}}</div>
          </div>
          <div class="row">
            <div class="col-5" >Zip</div>
            <div class="col-7" style="font-weight: bold;">{{data?.mailingAddress?.zipCode}}</div>
          </div>
          <div class="row">
            <div class="col-5" >Email</div>
            <div class="col-7" style="font-weight: bold;">{{data?.contactEmail}}</div>
          </div>
          <div class="row">
            <div class="col-5" >Phone</div>
            <div class="col-7" style="font-weight: bold;">{{data?.contactPhone}}</div>
          </div>
      </div>

      <div class="col-6">
        <div class="row">

          <div class="col-10">
            <div class="row">Fee
            </div>
          </div>
          <div class="col-2">${{summary?.amount}}
          </div>
        </div>
        <div class="row">
        *If paying via Credit/Debit Card a 2.29% convenience fee (${{summary?.amount + (summary?.amount*0.0229) | number:'2.0-2'}}) will be applied.
        </div>
        <div fxLayoutAlign="end"><button mat-raised-button (click)="onMakePayment()" color="primary">Make
            Payment</button></div>

      </div>
    </div>
    <div class="row">
      <button class="grey-button" mat-raised-button style="margin-left: 27px;margin-top: 50px;max-width: 120px;" (click)="onBack()">Back</button>
    </div>
  </div>
</div>
<ng-template #dialogRef let-data>
  <mat-expansion-panel [expanded]="true" hideToggle>
    <mat-expansion-panel-header class='header' style="pointer-events: none;">
      <mat-panel-description>{{data.title}}
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div fxLayoutAlign="center">
      <p class="mt-3 mb-3 breakline">{{data.message}}</p>
    </div>
    <div fxLayoutAlign="center">
      <button class="grey-button"  style="margin-left: 10px" mat-raised-button mat-dialog-close>No</button>
      <button class="grey-button" color="primary" mat-raised-button form="ngForm" style="margin-left: 10px" type="submit" (click)="formRef.submit()">Yes</button>
    </div>
  </mat-expansion-panel>
</ng-template>
